import styled from "styled-components";
import { formatter } from "../../../../constants/moneyString";
import {
  Trash,
  Percent,
  MagnifyingGlass,
  ArrowsClockwise,
} from "phosphor-react";
import { useFirestore } from "react-redux-firebase";
import { priceItems } from "../../constants";

const Container = styled.div`
  padding: 15px;
  padding-right: 40px;
  margin-top: 10px;
  border-radius: 3px;
  border: 1px solid transparent;
  background: ${({ color }) => color};
  display: flex;
  justify-content: space-between;
  box-shadow: 5px 4px 15px 4px rgb(121 139 121 / 14%);
  position: relative;
  transition: all 0.2s ease;
`;

const TitleBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const TitleInput = styled.input`
  border: none;
  color: black;
  padding: 5px;
  border-radius: 3px !important;
  font-weight: 700;
  margin-left: 10px;
  width: 80%;
`;
const AmountInput = styled.input`
  border: none;
  color: black;
  padding: 5px;
  border-radius: ${({ rounded }) => (!rounded ? "3px" : "0px")} !important;
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
  font-weight: 700;
`;

const TrashIcon = styled.div`
  color: white;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 5px;
  &:hover {
    border: 1px solid white;
  }
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 3px !important;
`;

const PercentIcon = styled.div`
  color: white;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 5px;
  &:hover {
    border: 1px solid white;
  }
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 3px !important;
`;

const SearchButton = styled.div`
  padding: 5px;
  color: ${({ selected }) => (selected ? "black" : "white")};
  cursor: pointer;
  border: 1px solid transparent;

  &:hover {
    border: 1px solid white;
  }
  border-radius: 3px !important;
  background: ${({ selected }) => (selected ? "white" : "transparent")};
`;

const KitDropdown = styled.select`
  border: none;
  color: black;
  padding: 5px;
  border-radius: 3px !important;
  font-weight: 700;
  margin: 0 10px;
  width: 100%;
  text-transform: uppercase;
  option {
  }
`;

const Pricing = styled.div`
  width: 40%;
  display: flex;
`;

const RefreshButton = styled.div`
  padding: 3px;
  color: ${({ color }) => color};
  cursor: pointer;
  border: 2px solid transparent;
  &:hover {
    border: 2px solid ${({ color }) => color};
  }
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  background: white;
`;

const Item = ({
  yurt,
  item,
  index: itemIndex,
  yurtIndex: kitIndex,
  doc,
  storedDocuments,
  setStoredDocuments,
  categoryIndex,
  color,
  prices,
  kit,
}) => {
  const firestore = useFirestore();

  const editItem = (name, value, kitIndex, itemIndex) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[kitIndex].items[categoryIndex].category[
      itemIndex
    ][name] = value;
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const deleteItem = (kitIndex, itemIndex) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[kitIndex].items[categoryIndex].category.splice(
      itemIndex,
      1
    );
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const handleTax = (kitIndex, itemIndex) => {
    let docs = [...storedDocuments];
    let item =
      docs[docs.indexOf(doc)].kits[kitIndex].items[categoryIndex].category[
        itemIndex
      ].tax;
    docs[docs.indexOf(doc)].kits[kitIndex].items[categoryIndex].category[
      itemIndex
    ].tax = !item;
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const handleDropdown = (title, amount, kitIndex, itemIndex) => {
    editItem("title", title, kitIndex, itemIndex);
    editItem("amount", amount, kitIndex, itemIndex);
  };

  let priceCategories = prices.filter(
    (priceKit) => priceKit.title === kit.size
  )[0];

  return (
    <Container
      key={item.title + item.amount + yurt.id + itemIndex}
      color={color}
    >
      <TitleBox>
        <SearchButton
          onClick={() =>
            editItem("searchPrices", !item.searchPrices, kitIndex, itemIndex)
          }
          selected={item.searchPrices}
        >
          <MagnifyingGlass weight="bold" />
        </SearchButton>
        {item.searchPrices ? (
          <>
            {kit.size && priceCategories ? (
              <KitDropdown
                onChange={(e) =>
                  handleDropdown(
                    e.target.value,
                    priceCategories[e.target.value],
                    kitIndex,
                    itemIndex
                  )
                }
                defaultValue={item.title}
              >
                <option>select part</option>
                {Object.keys(priceCategories)
                  .sort()
                  .map(
                    (key, keyIndex) =>
                      priceItems[key] && (
                        <option key={key} value={key}>
                          {priceItems[key]}
                        </option>
                      )
                  )}
              </KitDropdown>
            ) : null}
          </>
        ) : (
          <TitleInput
            autoComplete="off"
            name="title"
            onBlur={(e) =>
              editItem(e.target.name, e.target.value, kitIndex, itemIndex)
            }
            defaultValue={
              item.title in priceItems ? priceItems[item.title] : item.title
            }
          ></TitleInput>
        )}
      </TitleBox>
      <Pricing>
        <AmountInput
          rounded={item.searchPrices}
          type="currency"
          autoComplete="off"
          name="amount"
          onChange={(e) => formatter.format(e.target.value)}
          onBlur={(e) =>
            editItem(
              e.target.name,
              parseFloat(e.target.value.replace(/[^0-9.-]+/g, "")),
              kitIndex,
              itemIndex
            )
          }
          defaultValue={formatter.format(item.amount)}
        ></AmountInput>
        {item.searchPrices && (
          <RefreshButton color={color}>
            <ArrowsClockwise weight="fill" />
          </RefreshButton>
        )}
      </Pricing>

      <TrashIcon onClick={() => deleteItem(kitIndex, itemIndex)}>
        <Trash />
      </TrashIcon>
      <PercentIcon
        style={{
          background: item.tax ? "transparent" : "white",
          color: item.tax ? "white" : "black",
        }}
        onClick={() => handleTax(kitIndex, itemIndex)}
      >
        <Percent />
      </PercentIcon>
    </Container>
  );
};

export default Item;
